import React from "react";
import { FiTrash2, FiEye, FiEyeOff, FiX } from "react-icons/fi";

const BulkActionsBar = ({
  selectedItems,
  totalItems,
  onSelectAll,
  onDeselectAll,
  onBulkDelete,
  onBulkPublish,
  onBulkUnpublish,
  itemType = "items",
}) => {
  const selectedCount = selectedItems.length;
  const allSelected = selectedCount > 0 && selectedCount === totalItems;

  if (selectedCount === 0) return null;

  return (
    <div className="bg-blue-600 text-white px-4 py-3 rounded-lg shadow-lg mb-4 animate-in fade-in duration-200">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <span className="font-medium">
            {selectedCount} {itemType} selected
          </span>

          <div className="flex items-center gap-2">
            {!allSelected && (
              <button
                onClick={onSelectAll}
                className="text-sm bg-blue-700 hover:bg-blue-800 px-3 py-1 rounded transition-colors"
              >
                Select All ({totalItems})
              </button>
            )}

            <button
              onClick={onDeselectAll}
              className="text-sm bg-gray-600 hover:bg-gray-700 px-3 py-1 rounded transition-colors"
            >
              Deselect All
            </button>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <button
            onClick={onBulkPublish}
            className="flex items-center gap-1 bg-green-600 hover:bg-green-700 px-3 py-1 rounded transition-colors text-sm"
            title="Publish selected"
          >
            <FiEye size={14} />
            Publish
          </button>

          <button
            onClick={onBulkUnpublish}
            className="flex items-center gap-1 bg-yellow-600 hover:bg-yellow-700 px-3 py-1 rounded transition-colors text-sm"
            title="Unpublish selected"
          >
            <FiEyeOff size={14} />
            Unpublish
          </button>

          <button
            onClick={onBulkDelete}
            className="flex items-center gap-1 bg-red-600 hover:bg-red-700 px-3 py-1 rounded transition-colors text-sm"
            title="Delete selected"
          >
            <FiTrash2 size={14} />
            Delete ({selectedCount})
          </button>

          <button
            onClick={onDeselectAll}
            className="p-1 hover:bg-white/20 rounded transition-colors"
            title="Close bulk actions"
          >
            <FiX size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkActionsBar;
